import { getCurrentScope } from '@vue/composition-api';

const useRoute = () => ({
  value: getCurrentScope().vm.$root.$route,
});

export default useRoute;
